import styled from "styled-components";
import { Box } from "@mui/material";

export const CMHeadingContainer = styled.div((props) => ({
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  flexDirection: "row",
  paddingTop: 20,

  [`@media${props.theme.breakpoints.lg}`]: {
    flexDirection: "column",
  },

  [`@media${props.theme.breakpoints.xs}`]: {
    flexDirection: "column",
  },
}));

export const CMBoxcontainer = styled.div((props) => ({
  display: "flex",
  flexDirection: "column",

  [`@media${props.theme.breakpoints.lg}`]: {
    height: "auto",
  },
  [`@media${props.theme.breakpoints.xs}`]: {
    height: "auto",
  },
}));
export const CMBox = styled(Box)((props) => ({
  textAlign: "left",
  backgroundColor: " #F3FAFC",
  borderRadius: 33,
  height: 153,
  marginTop: 20,
  fontFamily: props.theme.fontFamilies.jost,
  fontWeight: "normal",
  marginLeft: "2%",
  marginRight: "2%",
  "& h4": {
    textAlign: "center",
    paddingTop: "2%",
    fontFamily: props.theme.fontFamilies.workSans,
    marginBottom: 0,
  },
  "& .container": {
    display: "flex",
    flexDirection: "row",
    paddingTop: "2%",
    justifyContent: "center",
    height: 100,
    fontWeight: "normal",
    "& div": {
      height: "100px",
      marginBottom: "20px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    "& input": {
      height: "66px",
      width: "73px",
      padding: "5px",
      textAlign: "center",
      fontSize: 32,
      border: "1px solid #ccc",
      borderRadius: "5px",
      fontFamily: props.theme.fontFamilies.jost,
    },

    "& .column1": {
      "& input": {
        borderRight: "none",
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        height: "66px",
        width: "60px",
      },
    },
    "& .column2": {
      "& input": {
        borderTopLeftRadius: 2,
        borderBottomLeftRadius: 2,
        height: "66px",
        width: "168px",
      },
    },
  },
  [`@media ${props.theme.breakpoints.lg}`]: {
    height: "auto !important",

    "& .container": {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      alignItems: "center",
      height: "auto",
    },
    "& input": {
      width: "94% !important",
    },
    "& .column1, .column2": {
      width: "100% !important",
      height: "auto !important",
    },
  },
}));
export const CMFooter = styled.div((props) => ({
  display: "flex",
  alignItems: "left",
  justifyContent: "center",

  "& h5": {
    margin: 0,
    paddingRight: "8%",
    paddingLeft: "15%",
    fontFamily: props.theme.fontFamilies.jost,
    fontWeight: "normal",
    textAlign: "left",
    paddingTop: "2%",
  },
  [`@media ${props.theme.breakpoints.lg}`]: {
    "& h5": {
      paddingLeft: "5%",
    },
  },
  [`@media ${props.theme.breakpoints.xs}`]: {
    "& h5": {
      paddingLeft: "5%",
    },
  },
}));

export const CMImage = styled.div((props) => ({
  display: "flex",
  flexDirection: "row",
  borderRadius: "13%",
  alignItems: "center",
  justifyContent: "center",
  border: "solid 1px #707070",
  backgroundColor: "#FFFFFF",
  height: 76,
  width: 127,
  marginLeft: 18,

  "& img": {
    width: "75%",
  },

  [`@media ${props.theme.breakpoints.lg}`]: {
    "& img": {
      width: "100%",
    },
  },

  [`@media ${props.theme.breakpoints.xs}`]: {
    "& img": {
      width: "100%",
    },
  },
}));
export const CMOffer = styled.div((props) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "left",
  paddingBottom: "5%",
  paddingTop: 34,
  "& Button": {
    height: 53,
    width: 344,
    fontFamily: props.theme.fontFamilies.jost,
    fontSize: 28,
    borderRadius: 30,
  },
  "& .ContinueButton": {
    marginLeft: "18%",
  },
  "& .BackButton": {
    width: 80,
  },
  [`@media ${props.theme.breakpoints.lg}`]: {
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    "& .ContinueButton": {
      marginLeft: 0,
    },
    "& Button": {
      width: 300,
    },
  },
  [`@media ${props.theme.breakpoints.xs}`]: {
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    "& .ContinueButton": {
      marginLeft: 0,
    },
    "& Button": {
      width: 300,
    },
  },
}));
